import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'

import { actions } from 'redux/slice/app'
import { selectEnableNoticePopup, selectIsMemberAnnounceLoaded } from 'redux/selector/app'
import { NOTICE_POPUP_DISMISSED_DATE_KEY } from 'constant/common'

import noticeImage from '@theme/notice-popup/notice.png'

import { Overlay, Content, NoticeImage, Footer, CheckboxLabel, CloseButton } from './Styled'

const today = () => dayjs().format('YYYY-MM-DD')

const isDismissedToday = () => {
  return localStorage.getItem(NOTICE_POPUP_DISMISSED_DATE_KEY) === today()
}

export default function NoticePopup() {
  const dispatch = useDispatch()
  const isLoaded = useSelector(selectIsMemberAnnounceLoaded)
  const enableNoticePopup = useSelector(selectEnableNoticePopup)
  const [dontRemind, setDontRemind] = useState(false)
  const [visible, setVisible] = useState(() => !isDismissedToday())

  const shouldShow = isLoaded && enableNoticePopup && visible

  useEffect(() => {
    if (isLoaded && !shouldShow) {
      dispatch(actions.dismissNoticePopup())
    }
  }, [isLoaded, shouldShow, dispatch])

  if (!shouldShow) return null

  const handleClose = () => {
    if (dontRemind) {
      localStorage.setItem(NOTICE_POPUP_DISMISSED_DATE_KEY, today())
    }
    setVisible(false)
  }

  return (
    <Overlay onClick={handleClose}>
      <Content onClick={(e) => e.stopPropagation()}>
        <NoticeImage src={noticeImage} alt="notice" />
      </Content>
      <Footer onClick={(e) => e.stopPropagation()}>
        <CheckboxLabel>
          <input
            type="checkbox"
            checked={dontRemind}
            onChange={(e) => setDontRemind(e.target.checked)}
            data-testid="notice_popup_dont_remind"
            aria-label="notice_popup_dont_remind"
          />
          本日不再提醒
        </CheckboxLabel>
        <CloseButton
          onClick={handleClose}
          data-testid="notice_popup_close"
          aria-label="notice_popup_close"
        >
          ✕
        </CloseButton>
      </Footer>
    </Overlay>
  )
}
